// Third-party imports
// import $ from 'jquery';

// Module name
export const MODULE_NAME = 'select_variant';

export let global_vars = {};

export function initialize(global) {
    let all_option = global.document.querySelectorAll(
        '.js-variantOptions-hook'
    );
    for (let option of all_option) {
        option.addEventListener('change', event => {
            let curopt = event.currentTarget;
            let selected = curopt.selectedIndex;
            let available = curopt.options[selected].dataset.isAvailable;
            let add_to_cart_button_id =
                curopt.options[selected].dataset.addToCartButtonId;
            let in_cart = curopt.options[selected].dataset.inCart;
            let cart_quantity = curopt.options[selected].dataset.cartQuantity;
            let variant_id = curopt.options[selected].attributes['value'].value;
            let form = curopt.closest('form[method="post"]');
            let idHiddenInput = form.querySelector('input[name="id"]');
            idHiddenInput.setAttribute('value', variant_id);
            idHiddenInput.dataset.inCart = in_cart;
            idHiddenInput.dataset.cartQuantity = cart_quantity;
            let giftIDHiddenInput = form.querySelector(
                'input[name="properties[gift_id]"]'
            );
            let gift_id = curopt.options[selected].dataset.giftIdSku;
            giftIDHiddenInput.setAttribute('value', gift_id);
            let addButton = document.querySelector('#' + add_to_cart_button_id);
            let soldOutButton = document.querySelector(
                '#soldOut' + add_to_cart_button_id
            );
            if (addButton && soldOutButton) {
                if (available === 'true') {
                    addButton.classList.remove('button--removed');
                    soldOutButton.classList.add('button--removed');
                } else {
                    addButton.classList.add('button--removed');
                    soldOutButton.classList.remove('button--removed');
                }
            }
        });
    }
}
